// Constantes de cómo se pintan las promos en el wizard: grupos del detalle y colores por tipo.

/** Promos que muestra cada grupo del detalle antes de «+N más». */
export const PROMOTION_GROUP_LIMIT = 3;

/** Chip o burbuja de cupón: pizarra, para no confundirse con el morado de crédito. */
export const COUPON_CHIP = 'bg-seg-slate-soft text-seg-slate';

/** Fondo y texto de cada grupo del detalle. */
export const PROMOTION_GROUP_TONE = {
    gift: { box: 'bg-info-soft', text: 'text-info' },
    discount: { box: 'bg-success-soft', text: 'text-success' },
    benefit: { box: 'bg-warning-soft', text: 'text-warning' },
    coupon: { box: 'bg-seg-slate-soft', text: 'text-seg-slate' },
    credit: { box: 'bg-promo-soft', text: 'text-promo' },
} as const;

export type PromotionGroupTone = keyof typeof PROMOTION_GROUP_TONE;

/** Marca de la promo elegida: anillo de 2px y punto relleno del color de su grupo. */
export const PROMOTION_GROUP_SELECTED: Record<PromotionGroupTone, { ring: string; fill: string }> =
    {
        gift: { ring: 'ring-info', fill: 'border-info bg-info' },
        discount: { ring: 'ring-success', fill: 'border-success bg-success' },
        benefit: { ring: 'ring-warning', fill: 'border-warning bg-warning' },
        coupon: { ring: 'ring-seg-slate', fill: 'border-seg-slate bg-seg-slate' },
        credit: { ring: 'ring-promo', fill: 'border-promo bg-promo' },
    };
